// extracted by mini-css-extract-plugin
export default {"container":"styles_container__iSEiC","text":"styles_text__id0i7"};